fragment workOrderInfo on WorkOrder {
  code
  completed
  customerName
  customWorkOrderFieldSelections {
    id
    customWorkOrderField {
      id
      label
    }
    customWorkOrderFieldValue {
      id
      description
      indicator
    }
  }
  description
  due
  endAt
  externalId
  externalUuid
  flag
  id
  missingData
  itemCategory {
    name
  }
  itemClass {
    name
  }
  itemCode
  itemDescription
  itemFamily {
    name
  }
  itemRecommendation {
    recommendedPeople
    recommendedProductionRate
  }
  itemType {
    name
  }
  materialAvailabilityDate
  notes
  pastDue
  performance
  productionRateDependsOnNumberOfPeople
  quantity
  producedQuantity
  productionLastUpdatedAt
  reference1
  reference2
  reference3
  reference4
  reference5
  remainingDuration
  requiredDuration
  schedulable
  scheduledDuration
  scheduledQuantity
  scheduledStatus
  serviceCategory {
    name
  }
  standardPeople
  standardProductionRate
  startAt
  status
  unitOfMeasure
  unschedulable
  unscheduledQuantity
  lineTypePreferencePrimary
  lineTypePreferenceSecondary
  workOrderPriority {
    priority
    description
  }
}
